// extracted by mini-css-extract-plugin
module.exports = {"logo":"SherpanyTopLogo_logo__mZ9wr"};